import { render } from "./IdentificationHistory.vue?vue&type=template&id=5721e831"
import script from "./IdentificationHistory.vue?vue&type=script&lang=js"
export * from "./IdentificationHistory.vue?vue&type=script&lang=js"
script.render = render

export default script